import Recommendations from '@jsclasses/recommendations';

const recommendationsWrapperClass = '.js-list__wrapper-recommendations';
const recommendationsWrapper = document.querySelector(
  recommendationsWrapperClass
);
const maxVisibleItems = recommendationsWrapper.dataset.numberOfVisibleProducts;

new Recommendations({
  wrapper: recommendationsWrapper,
  showPrice: true,
  maxVisibleItems: maxVisibleItems,
  staticContent: true
});
